export default function handleForbidden(dispatch: any, error: any) {
  if (error?.code === 403) {
    dispatch.acceptance.get({ id: 'me' });
  }
}
